"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertifiedID = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var recognition_1 = require("../../model/recognition");
var service_1 = require("../../../library/base/service");
var CertifiedID = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CertifiedID, _super);
    function CertifiedID() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '身份证号认证接口';
        _this.code = '101046';
        _this.desc = '身份证号认证接口';
        _this.requestParams = new recognition_1.CertifiedIDRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CertifiedID;
}(service_1.BaseService));
exports.CertifiedID = CertifiedID;
//# sourceMappingURL=certifiedID.js.map